import * as React from 'react';
import './BarcodeModal.scss';
import Modal from 'src/components/common/Modal/Modal';
import Button from 'src/components/common/Button';
import returnsServiceInstance from 'src/services/returns/returnsService';
import useMobile from 'src/hooks/useMobile';
import ReactToPrint from 'react-to-print'
import localeFormatingInstance from 'src/translation/localeFormating';
import ShippingLabelToPrint from '../ShippingLabelToPrint';
import { map } from 'lodash';
import i18n from 'src/translation/i18n';
import env from 'src/shared/env';
import CaShippingLabelWIndow from '../CaShippingLabelWIndow';

interface IBarcodeModalProps {
  handleCloseModal: () => void;
  rmaBarcode: string;
  downloadPdf: (rmaNumber: string, isPrepaidLabel: string) => void;
  isDownloadingPdf: boolean;
  upsResponseDataForBarcodeModal:any[];
  upsShippingErrorMessageForBarcodeModal: string;
  accountID: string;
}

const BarcodeModal: React.FC<IBarcodeModalProps> = props => {


  
  const { handleCloseModal, rmaBarcode, downloadPdf, isDownloadingPdf, upsResponseDataForBarcodeModal, upsShippingErrorMessageForBarcodeModal  } = props;
  const [barCodeImage, setBarCodeImage] = React.useState<string>('');
  const [isLoadingBarcode, setisLoadingBarcode] = React.useState<boolean>(
    false
  );
  const [defaultWarehouselist, setDefaultWarehouselist] = React.useState([]);
  const [isDownloadingDetails, setIsDownloadingDetails] = React.useState<boolean>(false);
  const [documentTitle, setDocumentTitle] = React.useState<string>('');
  const [shippingLabelUrl, setShppingLabelUrls] = React.useState<any>([]);
  const [cAPrintLabelReady, setCaPrintLabelReady] = React.useState<boolean>(false);
  const isMobile = useMobile();
  const componentShippingRef = React.useRef();

  const getBarCode = () => {

    setisLoadingBarcode(true);
    returnsServiceInstance.getCodebarRMAList(rmaBarcode).then(barcode => {
      setBarCodeImage(barcode);
      setisLoadingBarcode(false);
    });
  };

  const getWherehouse = () => {
    return returnsServiceInstance.getWherehouseList().then(WareHousesList => {
       setDefaultWarehouselist(WareHousesList);
    });
    

  };

  const getShippingLabelUrl = () => {
    setisLoadingBarcode(true);
    const shippingLabelUrlArr:any=[];
    upsResponseDataForBarcodeModal.map((url=>{
      shippingLabelUrlArr.push(url.labelPath)
    }));
    setShppingLabelUrls(shippingLabelUrlArr);
  };

  const getCaPrintingLabel = () => {
    setisLoadingBarcode(false);
    setCaPrintLabelReady(true);
  };


  const getUsPrintingLabel = (rmaBarcodeNo: string, upsDataCount: number ) => {
    setisLoadingBarcode(false);
    setCaPrintLabelReady(false);
    if(upsDataCount>0){
      downloadPdf(rmaBarcodeNo,'yes');
    }else{
      downloadPdf(rmaBarcodeNo,'no');
    }
  };

  const clickedPrintDetails = () => {
    setisLoadingBarcode(false);
    setCaPrintLabelReady(false);
  };

  

  const closeWindowPortal = () => {
   // Close Here
  };

  

  React.useEffect(() => {
    getBarCode();
    getShippingLabelUrl();
    getWherehouse();
  }, []);

  const mobileStyles = {
    width: '100%'
  };

  return (
    <Modal
      handleCloseModal={handleCloseModal}
      styles={isMobile ? mobileStyles : {}}
    >
      <div className="rp-barcode-modal">
      <div style={{ display: 'none' }}>
        <ShippingLabelToPrint
          ref={componentShippingRef}
          shippingLabel={shippingLabelUrl}
        />
      </div>
        
       {cAPrintLabelReady &&
        <CaShippingLabelWIndow 
        closeWindowPortal={closeWindowPortal}
        >
            {shippingLabelUrl.map((img: any, index: number) =>
                <div className="rp-content-to-print-row" key={index}>
                <div className="container-fluid">
                      <p className="rp-content-to-print-row-content quantity text-center">
                      <object data={img} type="application/pdf" style={{width: "100%",height: "100%"}} >
                      <embed src={img} type="application/pdf" style={{width: "100%",height: "100%"}} />
                      </object> 
                      </p>
                </div>
              </div>
              )}
        </CaShippingLabelWIndow>
        }

     
        <div className="container-fluid">
          <div className="row">
            <div className="col-12 d-flex justify-content-between">
              <h3>{env.REACT_APP_BASE_ENVIRONMENT === 'CA'
            ? i18n.t('RMAbarcode.returnInstructionsCA')
            : i18n.t('RMAbarcode.returnInstructions')}</h3>               
              <i className="rpds-close" onClick={handleCloseModal} />
            </div>
          </div>
         <div className="row">
          <div className="col-12">
            <h3 className="rp-barcode-modal-point-level-1">Account: {props.accountID}</h3>
            </div>
          </div>
          <div className="row">
            <div className="col-12">
              <p className="rp-barcode-modal-point-level-1">
              {env.REACT_APP_BASE_ENVIRONMENT === 'CA'
            ? upsResponseDataForBarcodeModal.length>0 ? i18n.t('RMAbarcode.printReturnLevelShippingLabelCA') : i18n.t('RMAbarcode.printReturnLevelCA')
            : upsResponseDataForBarcodeModal.length>0 ? i18n.t('RMAbarcode.printReturnLevelShippingLabelCA') : i18n.t('RMAbarcode.printReturnLevel') }
              </p>
            </div>
          </div>

          {/* DO NOT show warehouse list when Prepaid Shipping Label */ }

          {upsResponseDataForBarcodeModal.length===0  && 
          <React.Fragment>
          <div className="row">
            <div className="col-12">
              <p className="rp-barcode-modal-point-level-1">
              {env.REACT_APP_BASE_ENVIRONMENT === 'CA'
            ? i18n.t('RMAbarcode.closestReliableReturnCA')
            : i18n.t('RMAbarcode.closestReliableReturn')}
              </p>
            </div>
          </div>
          <div className="row barcode-add">
            <div className="col-12">
              {defaultWarehouselist.map(results => (
                 <div className="Barcode-modal-addresses">
                <p><span className="Barcode-modal-addresses-heading">{results.addressLine4.toLowerCase()}</span> <br/>{results.addressLine}
                <br/>{results.addressLine4.toLowerCase()}, {results.postalCode}</p>
                </div>
              
              ))}             
            </div>
          </div>
          </React.Fragment>    
          }

          <div className="row">
            <div className="col-12">
              <p className="rp-barcode-modal-point-level-1">
              {env.REACT_APP_BASE_ENVIRONMENT === 'CA'
            ? upsResponseDataForBarcodeModal.length>0 ? i18n.t('RMAbarcode.attachReturnBarcodeShippingLabelCA') : i18n.t('RMAbarcode.attachReturnBarcodeCA')
            : upsResponseDataForBarcodeModal.length>0 ? i18n.t('RMAbarcode.attachReturnBarcodeShippingLabelCA') : i18n.t('RMAbarcode.attachReturnBarcode')}
              </p>
            </div>
          </div>

          <div className="row">
            <div className="col-12 d-flex justify-content-center">
              {isLoadingBarcode ? (
                <div className="rp-barcode-modal-loading">
                  <div className="loadingio-spinner-rolling-x8i9qka9tdm">
                    <div className="ldio-9coovtt1mti">
                      <div />
                    </div>
                  </div>
                </div>
              ) : (
                <img
                  src={`data:image/png;base64,${barCodeImage}`}
                  height="100"
                />
              )}
            </div>
          </div>

          <div className="row rp-barcode-modal-buttons">
            <div className="col-6 d-flex justify-content-end">
              <Button
                label={env.REACT_APP_BASE_ENVIRONMENT === 'CA'
                ? i18n.t('RMAbarcode.rmaCloseCA')
                : i18n.t('RMAbarcode.rmaClose')}
                buttonClass="rp-barcode-modal-button outlined"
                textTransform="uppercase"
                action={handleCloseModal}
              />
            </div>
            <div className="col-6 d-flex justify-content-start">
              <button
                onClick={() => getUsPrintingLabel(rmaBarcode, upsResponseDataForBarcodeModal.length)}
                className="rp-barcode-modal-button filled"
                disabled={isDownloadingPdf}
              >
                {isDownloadingPdf ? (
                  <div className="rp-barcode-modal-loading white-loader">
                    <div className="loadingio-spinner-rolling-x8i9qka9tdm">
                      <div className="ldio-9coovtt1mti">
                        <div />
                      </div>
                    </div>
                  </div>
                ) : (
                  <p>{env.REACT_APP_BASE_ENVIRONMENT === 'CA'
                  ? i18n.t('RMAbarcode.rmaPrintCA')
                  : i18n.t('RMAbarcode.rmaPrint')}</p>
                )}
              </button>
            </div>            
          </div>
          {upsShippingErrorMessageForBarcodeModal!=="" &&
          <div className="row">
            <div className="col-12 d-flex justify-content-center">
              <p className="error-msg">
               {upsShippingErrorMessageForBarcodeModal}
              </p>
            </div>
          </div>
          }
         
         
          {upsResponseDataForBarcodeModal.length>0 && env.REACT_APP_BASE_ENVIRONMENT === 'US' &&
          <div className="row">
            <div className="col-12">
              <p className="rp-barcode-modal-point-level-1 track-ship">
           
            <ReactToPrint
              onBeforeGetContent={() => {
                setDocumentTitle(document.title);
                document.title = `${localeFormatingInstance.getNowDate('short')}.pdf`;
                setIsDownloadingDetails(true);
              }}
              onAfterPrint={() => {
                document.title = documentTitle;
                setIsDownloadingDetails(false);
              }}
              trigger={() => (
                <div
                  className={`col-12 d-flex justify-content-center ${setIsDownloadingDetails &&
                    'disabled'}`}
                >
                <button
                className="shipping-button"
                disabled={isDownloadingDetails}
                onClick={() => clickedPrintDetails()}
                >
                  <p>{env.REACT_APP_BASE_ENVIRONMENT === 'CA'
                  ? i18n.t('RMAbarcode.printShippingLevelCA')
                  : i18n.t('RMAbarcode.printShippingLevel')}</p>
                  </button>
                </div>
              )}
              content={() => componentShippingRef.current}
              documentTitle={`${'Shipping-Label'}-${localeFormatingInstance.getNowDate('short')}.pdf`}
            />
             
              </p>
            </div>
          </div>
          }

          {upsResponseDataForBarcodeModal.length>0 && env.REACT_APP_BASE_ENVIRONMENT === 'CA' &&
          <div className="row">
            <div className="col-12">
              <p className="rp-barcode-modal-point-level-1 track-ship">
           
              <button
                className="shipping-button"
                disabled={isDownloadingDetails}
                onClick={() => getCaPrintingLabel()}
                >
                  <p>{env.REACT_APP_BASE_ENVIRONMENT === 'CA'
                  ? i18n.t('RMAbarcode.printShippingLevelCA')
                  : i18n.t('RMAbarcode.printShippingLevel')}</p>
                  </button>
             
              </p>
            </div>
          </div>
          }


          <div className="row">
            <div className="col-12">
              <p className="rp-barcode-modal-point-level-1 track-ship">
              {upsShippingErrorMessageForBarcodeModal!=="" ?
              i18n.t('RMAbarcode.rmaRetainTrackingWithShippingError')
              :
              env.REACT_APP_BASE_ENVIRONMENT === 'CA'
                  ? i18n.t('RMAbarcode.rmaRetainTrackingCA')
                  : i18n.t('RMAbarcode.rmaRetainTracking')
              }    
              </p>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default BarcodeModal;
